/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ strong: NonNullable<unknown> }} Misc_Posts_Expectlist_Characters1Inputs */

const id_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Kendalikan pahlawan dan penjahat favorit Anda dari galaksi yang jauh, jauh sekali.`)
};

const ms_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Kawal hero dan penjahat kegemaran anda dari galaksi yang jauh, jauh sekali.`)
};

const da_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Kontrollér dine yndlingshelte og -skurke fra galaksen langt, langt væk.`)
};

const de_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Steuern Sie Ihre Lieblingshelden und -schurken aus einer weit, weit entfernten Galaxie.`)
};

const en_us2_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Control your favorite heroes and villains from the galaxy far, far away.`)
};

const es_es2_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Controla a tus héroes y villanos favoritos de la galaxia muy, muy lejana.`)
};

const es_mx2_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🚀 ${i?.strong}: Controla a tus héroes y villanos favoritos de la galaxia muy, muy lejana.`)
};

const fil_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Kontrolin ang iyong mga paboritong bayani at kontrabida mula sa malayong kalawakan.`)
};

const fr_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong} : Contrôlez vos héros et vilains préférés de la galaxie lointaine, très lointaine.`)
};

const it_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Controlla i tuoi eroi e cattivi preferiti della galassia lontana lontana.`)
};

const hu_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Irányítsd kedvenc hőseidet és gonosztevőidet a messzi-messzi galaxisból.`)
};

const nl_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Bestuur je favoriete helden en schurken uit het verre, verre sterrenstelsel.`)
};

const no_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Styr dine favoritthelter og skurker fra en galakse langt, langt borte.`)
};

const pl_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Steruj ulubionymi bohaterami i złoczyńcami z odległej galaktyki.`)
};

const pt_br2_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Controle seus heróis e vilões favoritos de uma galáxia muito, muito distante.`)
};

const pt_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Controle os seus heróis e vilões favoritos da galáxia distante.`)
};

const ro_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Controlează-ți eroii și răufăcătorii preferați din galaxia îndepărtată.`)
};

const fi_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Ohjaa suosikkisankareitasi ja -konnojasi kaukaisesta galaksista.`)
};

const sv_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Kontrollera dina favorithjältar och -skurkar från galaxen långt, långt borta.`)
};

const vi_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Điều khiển các anh hùng và nhân vật phản diện yêu thích của bạn từ thiên hà xa xôi.`)
};

const tr_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Uzak bir galaksiden en sevdiğiniz kahramanları ve kötü adamları kontrol edin.`)
};

const cs_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Ovládejte své oblíbené hrdiny a padouchy z daleké galaxie.`)
};

const bg_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Контролирайте любимите си герои и злодеи от далечна галактика.`)
};

const ru_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Управляйте любимыми героями и злодеями из далёкой-далёкой галактики.`)
};

const uk_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: Керуйте улюбленими героями та лиходіями з далекої-далекої галактики.`)
};

const ar_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: تحكم بأبطالك وأشرارك المفضلين من مجرة بعيدة جدًا.`)
};

const hi_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: अपने पसंदीदा नायकों को नियंत्रित करें।`)
};

const th_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}: ควบคุมฮีโร่และวายร้ายที่คุณชื่นชอบจากกาแล็กซีอันไกลโพ้น`)
};

const ja_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}：はるか彼方の銀河系からお気に入りのヒーローとヴィランを操作。`)
};

const zh_cn2_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🛸 ${i?.strong}：控制来自遥远银河系中您最喜爱的英雄和反派。`)
};

const zh_hant1_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}：控制來自遙遠銀河系中您最喜愛的英雄和反派。`)
};

const ko_misc_posts_expectlist_characters1 = /** @type {(inputs: Misc_Posts_Expectlist_Characters1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: 은하계의 좋아하는 영웅과 악당을 조종하세요.`)
};

/**
* | output |
* | --- |
* | "🛸 {strong}: Control your favorite heroes and villains from the galaxy far, far away." |
*
* @param {Misc_Posts_Expectlist_Characters1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_characters1 = /** @type {((inputs: Misc_Posts_Expectlist_Characters1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Characters1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_characters1(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_characters1(inputs)
	if (locale === "da") return da_misc_posts_expectlist_characters1(inputs)
	if (locale === "de") return de_misc_posts_expectlist_characters1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_characters1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_characters1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_characters1(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_characters1(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_characters1(inputs)
	if (locale === "it") return it_misc_posts_expectlist_characters1(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_characters1(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_characters1(inputs)
	if (locale === "no") return no_misc_posts_expectlist_characters1(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_characters1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_characters1(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_characters1(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_characters1(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_characters1(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_characters1(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_characters1(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_characters1(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_characters1(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_characters1(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_characters1(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_characters1(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_characters1(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_characters1(inputs)
	if (locale === "th") return th_misc_posts_expectlist_characters1(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_characters1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_characters1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_characters1(inputs)
	return ko_misc_posts_expectlist_characters1(inputs)
});
export { misc_posts_expectlist_characters1 as "misc.posts.expectList.characters" }